var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowSharp = function SvgArrowSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ARROW-SHARP_svg__cls-1",
    d: "M512 255.92v.18l-21.36 21.36L256.09 512l-21.45-21.45L453.2 272H0v-32h453.18L234.64 21.46l8-8L256.09.01 512 255.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ARROW-SHARP_svg__cls-1",
    d: "M16.08 240 0 256.08V240h16.08z"
  })));
};
export { SvgArrowSharp as ReactComponent };
export default "data:image/svg+xml,%3csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e %3cdefs%3e %3c/defs%3e %3cpolygon class='cls-1' points='512 255.92 512 256.1 490.64 277.46 256.09 512 234.64 490.55 453.2 272 0 272 0 240 453.18 240 234.64 21.46 242.64 13.46 256.09 .01 512 255.92'/%3e %3cpolygon class='cls-1' points='16.08 240 0 256.08 0 240 16.08 240'/%3e %3c/svg%3e";